import { createAction } from "@reduxjs/toolkit";

import type { IUser } from "./auth.model";

export const signedOut = createAction("app/signedOut");

export const setUser = createAction<IUser | undefined>("app/setUser");
